(function () {
  if (window.OTTUNIOffice) {
    window.OTTUNIOffice.init(document);
    return;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initSupport(scope) {
    scope.querySelectorAll('[data-oh-support]:not([data-oh-ready])').forEach(function (root) {
      var triggers = Array.prototype.slice.call(root.querySelectorAll('.oh-support__trigger'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-oh-support-item]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.oh-support__panel'));

      if (!triggers.length) return;
      root.dataset.ohReady = 'true';

      function setFeature(index, moveFocus) {
        var nextIndex = (index + triggers.length) % triggers.length;
        var activeTrigger = triggers[nextIndex];
        var activePanelId = activeTrigger.getAttribute('aria-controls');

        triggers.forEach(function (trigger, triggerIndex) {
          var active = triggerIndex === nextIndex;
          trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
          if (active && moveFocus) trigger.focus();
        });

        items.forEach(function (item, itemIndex) {
          item.classList.toggle('is-active', itemIndex === nextIndex);
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.id !== activePanelId;
        });

        root.style.setProperty('--oh-focus-x', activeTrigger.dataset.focusX + '%');
        root.style.setProperty('--oh-focus-y', activeTrigger.dataset.focusY + '%');
        root.style.setProperty('--oh-focus-scale', activeTrigger.dataset.focusScale);
        root.dataset.ohChanging = 'true';
        window.setTimeout(function () {
          root.dataset.ohChanging = 'false';
        }, reduceMotion.matches ? 0 : 720);
      }

      triggers.forEach(function (trigger, index) {
        trigger.addEventListener('click', function () {
          setFeature(index, false);
        });

        trigger.addEventListener('keydown', function (event) {
          var next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index + 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = triggers.length - 1;
          if (next === index) return;
          event.preventDefault();
          setFeature(next, true);
        });
      });

      root.querySelectorAll('[data-oh-support-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var current = triggers.findIndex(function (trigger) {
            return trigger.getAttribute('aria-expanded') === 'true';
          });
          setFeature(current + Number(button.dataset.ohSupportStep), false);
        });
      });

      setFeature(0, false);
    });
  }

  function initMaterials(scope) {
    scope.querySelectorAll('[data-oh-materials]:not([data-oh-ready])').forEach(function (root) {
      var track = root.querySelector('[data-oh-material-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-oh-material-slide]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-oh-material-tab]'));
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-oh-material-step]'));
      var index = 0;

      if (!track || !slides.length) return;
      root.dataset.ohReady = 'true';

      function setMaterial(nextIndex, moveFocus, shouldScroll) {
        index = Math.max(0, Math.min(slides.length - 1, nextIndex));

        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        tabs.forEach(function (tab, tabIndex) {
          var active = tabIndex === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });

        steps.forEach(function (step) {
          var direction = Number(step.dataset.ohMaterialStep);
          step.disabled = direction < 0 ? index === 0 : index === slides.length - 1;
        });

        if (shouldScroll) {
          track.scrollTo({
            left: slides[index].offsetLeft,
            behavior: reduceMotion.matches ? 'auto' : 'smooth'
          });
        }
      }

      tabs.forEach(function (tab, tabIndex) {
        tab.addEventListener('click', function () {
          setMaterial(tabIndex, false, true);
        });

        tab.addEventListener('keydown', function (event) {
          var next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index + 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = slides.length - 1;
          if (next === index) return;
          event.preventDefault();
          setMaterial(next, true, true);
        });
      });

      steps.forEach(function (step) {
        step.addEventListener('click', function () {
          setMaterial(index + Number(step.dataset.ohMaterialStep), false, true);
        });
      });

      root.addEventListener('keydown', function (event) {
        if (event.target.closest('[data-oh-material-tab]')) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setMaterial(index + 1, false, true);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setMaterial(index - 1, false, true);
        }
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.58) {
                setMaterial(Number(entry.target.dataset.ohMaterialSlide), false, false);
              }
            });
          },
          { root: track, threshold: [0.58, 0.72] }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      setMaterial(0, false, false);
    });
  }

  function initVideos(scope) {
    scope.querySelectorAll('[data-oh-video]:not([data-oh-ready])').forEach(function (root) {
      var video = root.querySelector('video');
      var button = root.querySelector('[data-oh-video-toggle]');
      var label = root.querySelector('[data-oh-video-label]');

      if (!video || !button || !label) return;
      root.dataset.ohReady = 'true';

      function sync() {
        var paused = video.paused;
        button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        label.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      }

      button.addEventListener('click', function () {
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
        sync();
      });

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);

      if (reduceMotion.matches) video.pause();
      sync();
    });
  }

  function initStories(scope) {
    scope.querySelectorAll('[data-oh-stories]:not([data-oh-ready])').forEach(function (root) {
      var track = root.querySelector('[data-oh-story-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-oh-story-slide]'));
      var count = root.querySelector('[data-oh-story-count]');
      var controls = root.querySelector('.oh-stories__controls');
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-oh-story-step]'));
      var frame = null;

      if (!track || !slides.length) return;
      root.dataset.ohReady = 'true';

      function getVisibleRange() {
        var left = track.scrollLeft;
        var right = left + track.clientWidth;
        var visible = [];

        slides.forEach(function (slide, slideIndex) {
          var center = slide.offsetLeft + slide.offsetWidth / 2;
          if (center >= left && center <= right) visible.push(slideIndex);
        });

        if (!visible.length) {
          var nearest = slides.reduce(function (best, slide, slideIndex) {
            return Math.abs(slide.offsetLeft - left) < Math.abs(slides[best].offsetLeft - left)
              ? slideIndex
              : best;
          }, 0);
          visible.push(nearest);
        }

        return {
          first: visible[0],
          last: visible[visible.length - 1]
        };
      }

      function sync() {
        frame = null;
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var hasOverflow = maxScroll > 2;
        var range = getVisibleRange();

        root.classList.toggle('has-overflow', hasOverflow);
        if (controls) controls.hidden = !hasOverflow;
        if (buttons[0]) buttons[0].disabled = !hasOverflow || track.scrollLeft <= 2;
        if (buttons[1]) buttons[1].disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;

        if (!count) return;
        if (slides.length === 1) {
          count.textContent = '01';
        } else if (range.first === range.last) {
          count.textContent = pad(range.first + 1) + ' / ' + pad(slides.length);
        } else {
          count.textContent =
            pad(range.first + 1) +
            ' — ' +
            pad(range.last + 1) +
            (range.last - range.first + 1 < slides.length ? ' / ' + pad(slides.length) : '');
        }
      }

      function requestSync() {
        if (frame !== null) return;
        frame = window.requestAnimationFrame(sync);
      }

      function move(direction) {
        var range = getVisibleRange();
        var current = direction > 0 ? range.first + 1 : range.first - 1;
        var next = Math.max(0, Math.min(slides.length - 1, current));
        track.scrollTo({
          left: slides[next].offsetLeft,
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          move(Number(button.dataset.ohStoryStep));
        });
      });

      track.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });

      track.addEventListener('scroll', requestSync, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(requestSync).observe(track);
      } else {
        window.addEventListener('resize', requestSync);
      }

      sync();
    });
  }

  function init(scope) {
    initSupport(scope);
    initMaterials(scope);
    initVideos(scope);
    initStories(scope);
  }

  window.OTTUNIOffice = { init: init };
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  init(document);
})();
